/*! © CREATE-REACT-APP */
import smoothscroll from 'smoothscroll-polyfill';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.string.includes';
import 'core-js/web/url-search-params';
import 'core-js/stable/promise';
import 'core-js/stable/promise/all-settled';

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// Needed when using KibMediaImage on older browsers
if (typeof window !== 'undefined') {
  require('intersection-observer');
  require('picturefill');
  smoothscroll.polyfill();
}
